<template>
    <div id="app">
        <transition name="el-zoom-in-center" mode="out-in">
            <router-view></router-view>
        </transition>
    </div>
</template>

<script>
  /* ============
   * Entry Point
   * ============
   *
   * The entry point of the application
   */

  export default {
    /**
     * The name of the application.
     */
    name: 'merchantcenter',
    created () {}
  }
</script>



// WEBPACK FOOTER //
// src/app/App.vue